import type { FAQEntry, LinkSegments } from '$lib/components/seo/types';
import type { LanguageCode } from '$lib/i18n/language';
import { getSegmentsLabel, segments2href } from '$lib/components/seo/linkSegments';
import { i18nPath } from '$lib/i18n/routing';
import { replaceText } from './format';

interface FillTrafficDataArgs {
	question: string;
	answer: string;
	lang: LanguageCode;
}

export function fillTrafficData({ answer, question, lang }: FillTrafficDataArgs): FAQEntry {
	const answerHtml = replaceText(answer, {
		trafficUrl: i18nPath('/map/traffic', lang),
	});

	return {
		question,
		answerHtml,
	};
}

interface FillTrafficResultDataArgs {
	addressSegments: LinkSegments;
	trafficEventsCount: number;
	question: string;
	answer: string;
	lang: LanguageCode;
}

export function fillTrafficResultData({
	addressSegments,
	trafficEventsCount,
	answer,
	question,
	lang,
}: FillTrafficResultDataArgs): FAQEntry {
	const answerHtml = replaceText(answer, {
		trafficUrl: segments2href(addressSegments, lang, ['map', 'traffic']),
		localityLabel: getSegmentsLabel(addressSegments),
		trafficEventsCount: trafficEventsCount.toString(),
	});

	return {
		question: replaceText(question, {
			localityLabel: getSegmentsLabel(addressSegments),
		}),
		answerHtml,
	};
}
